import React from 'react'

export const MissionsStyles: { [key: string]: React.CSSProperties } = {
    container: {
        width: '100%',
        position: 'relative',
    },
    content: {
        width: '100%',
        paddingTop: 10,
        display: 'flex',
        overflow: 'auto',
        paddingBottom: 10,
        flexWrap: 'nowrap',
        boxSizing: 'border-box',
    },
    btnIcon: {
        marginRight: 5,
    },
    btnContent: {
        width: 220,
        minWidth: 220,
        maxWidth: 220,
        height: 235,
        minHeight: 235,
        maxHeight: 235,
        marginLeft: 5,
        marginRight: 10,
        display: 'flex',
        borderRadius: 10,
        cursor: 'pointer',
        paddingTop: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        position: 'relative',
        boxSizing: 'border-box',
        backgroundColor: '#fff',
        flexDirection: 'column',
        boxShadow: '0px 1px 3px 0px #0000001A',
    },
    btnHeader: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        boxSizing: 'border-box',
        justifyContent: 'flex-end',
    },
    btnBody: {
        flex: 1,
        height: '100%',
        display: 'flex',
        textAlign: 'start',
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    btnFooter: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    btnAction: {
        paddingTop: 10,
        paddingLeft: 20,
        borderRadius: 7,
        paddingRight: 20,
        cursor: 'pointer',
        paddingBottom: 10,
        backgroundColor: '#FFF',
        border: '1px solid #74BE00',
    },
    top: {
        display: 'flex',
        marginBottom: 15,
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    topTitle: {
        width: 210,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    topProgressContainer: {
        flex: 1,
        marginTop: 7,
        marginBottom: 7,
    },
    topRightContainer: { display: 'flex' },
    topStepContent: {
        width: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    topRightTextContent: {
        width: 150,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}
